export function parseDecimal(value: string | number): number {
  if (typeof value === 'string') {
    const clean = value.trim().replace(',', '.');
    const parsed = Number(clean);
    return !Number.isInteger(Number(parsed)) ? 0 : parsed;
  }
  if (typeof value === 'number') return value;
  return 0;
}
